"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LinkRenderer = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var LinkRenderer = function LinkRenderer(_ref) {
  var children = _ref.children,
      customLinkRenderer = _ref.customLinkRenderer,
      routeHref = _ref.routeHref,
      pageCode = _ref.pageCode,
      props = (0, _objectWithoutProperties2.default)(_ref, ["children", "customLinkRenderer", "routeHref", "pageCode"]);

  var link = _react.default.createElement("a", (0, _extends2.default)({
    href: routeHref
  }, props), children);

  if (customLinkRenderer) {
    link = customLinkRenderer(Object.assign({
      children: children,
      routeHref: routeHref,
      pageCode: pageCode
    }, props));
  }

  return link;
};

exports.LinkRenderer = LinkRenderer;